import { render, staticRenderFns } from "./HomeNav.vue?vue&type=template&id=264878c6&"
import script from "./HomeNav.vue?vue&type=script&lang=js&"
export * from "./HomeNav.vue?vue&type=script&lang=js&"
import style0 from "./HomeNav.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBottomNavigation } from 'vuetify/lib/components/VBottomNavigation';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContent } from 'vuetify/lib/components/VContent';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSlideXTransition } from 'vuetify/lib/components/transitions';
installComponents(component, {VBottomNavigation,VBtn,VContent,VIcon,VSlideXTransition})
